import { IRequesterInfo } from "../../../../../base/models"
import { ClientProxy } from "../../../../../base/proxy/clientProxy"
import { IFibaRequest, IFibaResponse } from "../models/model"


export class GetFibaListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/fiba/getFibaList',
      requesterInfo,
    })
  }

  public async getFibaList(req: IFibaRequest): Promise<IFibaResponse[]> {
    return await this.postAsync<IFibaResponse[]>(req)
  }
}